import { ITestIssueSchema } from '@/api/testIssue';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { UploadField } from '@/components/form/fields/UploadField';

export const AttachmentForm: React.FC = () => {
  const form = useFormContext<ITestIssueSchema>();

  form.trigger('medias');

  return (
    <UploadField
      name="medias"
      note="File size should be less than 2MB and allowed formats are .xls, .xlsx, .doc, .txt, .pdf, .csv, .log, .zip, .mp4, .webm, .ipynb, .odf, .gif, .png, .jpg, .ppt, .pptx, .mov"
      type="file"
      isMultiple
    />
  );
};
